// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e8036312","500":"96164caf","593":"beff046d"}[chunkId] + ".chunk.js";
};